let CzLabels;

export default CzLabels = {
    lbl_Titolo: 'Titolo',
    lbl_Tipo: "Tipo registrazione",
    lbl_Nome: "Nome",
    lbl_Cognome: "Cognome",

    lbl_TipoAzienda: "Ente/Azienda",
    lbl_TipoPersonale: "Persona",

    lbl_Uomo: "Uomo",
    lbl_Donna: "Donna",
    lbl_DataDiNascita: "Data di nascita",
    lbl_LuogoDiNascita: "Luogo di nascita",
    lbl_StatoDiNascita: "Nazione",
    lbl_Indirizzo: "Indirizzo",
    lbl_Provincia: "Provincia",
    lbl_State: "Nazione",

    lbl_CF: "Codice fiscale", 
    lbl_IVA: "Partita iva",

    lbl_City: "Città",
    lbl_Zip: "CAP",
    lbl_Cellulare: 'Cellulare',
    lbl_TelLavoro: 'Tel. lavoro',
    lbl_TelCasa: 'Tel. casa',
    lbl_Email: 'Email',
    lbl_Password: 'Password',
    lbl_Password2: 'Conferma',
    lbl_email_msg: 'L\'indirizzo email serve per poter accedere al sito',

    lbl_DocumentoIdentita: 'Documento identità',
    lbl_DocumentoIdentitaNazione: 'Nazione',
    lbl_DocumentoIdentitaNumero: 'Numero',
    lbl_DocumentoIdentitaScadenza: 'Scadenza',
    lbl_DocumentoIdentitaFronte: 'Immagine fronte',
    lbl_DocumentoIdentitaRetro: 'Immagine retro',
    lbl_DocumentoIdentitaData: 'Data emissione',

    lbl_titoloMsgErrore: 'Dati incompleti',
    lbl_invalidField: 'I seguenti campi non sono validi: ',


    lbl_VaiAPagina2: 'Successivo'
};